<template>
  <div>
    <!--  管理评审人列表组件-->
    <el-dialog
      :title="$t('common.manageReviewerMan')"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <div>
        <el-button type="primary" @click="handleCreateUserOpen"
          ><i class="el-icon-plus el-icon--left"></i>{{$t('common.createNewUser')}}</el-button
        >
        <el-button type="primary" @click="handleSearchUserOpen"
          ><i class="el-icon-search el-icon--left"></i>{{$t('common.searchAddUser')}}</el-button
        >
        <!--        {{paramSingleDocCode}}-->
      </div>
      <!--  拖拽表格-->
      <div style="max-height: 400px; overflow: auto">
        <table class="dataTabble">
          <thead>
            <tr>
              <th width="">{{$t('common.index')}}</th>
              <th width="">{{$t('common.name')}}</th>
              <th width="">{{$t('common.jigou')}}</th>
              <th width="">{{$t('common.registerEmail')}}</th>
              <th width="" v-if="false">{{$t('common.phone')}}</th>
              <th width="">{{$t('common.handle')}}</th>
            </tr>
          </thead>
          <tbody
            v-model="tableList"
            element="tbody"
            :move="getdata"
            @update="datadragEnd"
          >
            <tr v-for="(item, index) in tableList" :key="index">
              <!--              <td>-->
              <!--                <div style="width: 80px;">-->
              <!--                  <el-input v-model="item.randNum" oninput="value=value.replace(/[^\d]/g,'')" maxlength="10"></el-input>-->
              <!--                </div>-->
              <!--              </td>-->
              <td>{{ index + 1 }}</td>
              <td>{{ item.userName }}</td>
              <td>{{ item.orgName }}</td>
              <td>{{ item.mail }}</td>
              <td v-if="false">{{ item.phone }}</td>
              <td>
                <div class="tabopa">
                  <el-button
                    size="mini"
                    icon="el-icon-delete"
                    type="danger"
                    @click="handleDelete(index, item)"
                    >{{$t('common.delete')}}</el-button
                  >
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--  删除确认弹框-->
      <h-popup ref="delete" @confirm="confirmDelete">
        <template slot="title">{{ $t("common.tip") }}</template>
        <template slot="tip"> {{ $t("common.isConfirmdelete") }} </template>
      </h-popup>
      <!--  搜索用户添加   -->
      <search-add-user-component
        ref="search-add-user"
        @addUserFunc="addUserFunc"
        :roleCodeArr="['#ROLE1#ROLE2']"
      ></search-add-user-component>
      <!--  搜索用户添加   -->
      <search-create-user-component
        ref="search-create-user"
      ></search-create-user-component>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false"
          >{{ $t("common.cancelSpace") }}
        </el-button>
        <el-button type="primary" @click="clickQueBtn()">{{
          $t("common.trueText")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import hPopup from "@/components/common/hPopup";
import draggable from "vuedraggable";
import searchAddUserComponent from "@/components/paper/searchAddUserComponent";
import searchCreateUserComponent from "@/components/paper/searchCreateUserComponent";
export default {
  data() {
    return {
      paramSingleDocCode: "", //文章id
      currentId: "", //当前删除的id
      dialogVisible: false,
      tableList: [],
      cacheUserList: [],
    };
  },
  components: {
    draggable,
    hPopup,
    searchAddUserComponent,
    searchCreateUserComponent,
  },
  methods: {
    /**
     *  param1 请求回的数据   param2 最后的结果数据
     *  生成用户删除数组
     * */
    getDeleteArr(cacheArr, endArr) {
      let deleteArr = [];
      let meMap = new Map();
      if (endArr.length > 0) {
        endArr.map((y) => {
          meMap.set(y.userId, y);
        });
      }
      cacheArr.forEach((x) => {
        if (!meMap.get(x.userId)) {
          deleteArr.push(x);
        }
      });
      return deleteArr;
    },
    //分配评审人
    clickQueBtn() {
      this.deleteArr = this.getDeleteArr(this.cacheUserList, this.tableList);
      let data = {};
      data.docCode = this.paramSingleDocCode;
      //删除的数组。
      data.deleteEvaluationId = this.deleteArr.map((x) => {
        return x.userId;
      });
      //全部数据
      data.finalSaveEvaluationId = this.tableList.map((x) => {
        return { byDistributionId: x.userId, orgCode: x.orgCode };
      });
      this.$api.assignEvaluation(data).then((res) => {
        this.dialogVisible = false;
        this.$message.success(this.$t("msg.successMsg"));
        this.$emit("clickQue");
      });
    },
    //初始化弹出列表
    handleOpen(paramSingleDocCode) {
      this.paramSingleDocCode = paramSingleDocCode;
      this.dialogVisible = true;
      this.requestReviewerManList(paramSingleDocCode);
    },
    //请求列表
    requestReviewerManList(paramSingleDocCode) {
      let data = {
        docCode: paramSingleDocCode,
      };
      this.$api.selectReviewerOrgNameList(data, "get").then((res) => {
        if (res.code == 200) {
          this.tableList = res.data;
          this.cacheUserList = JSON.parse(JSON.stringify(res.data));
        }
      });
    },
    addUserFunc(item) {
      //添加查重
      item.randNum = this.tableList.length + 1;
      let flag = true;
      this.tableList.some((x) => {
        if (x.userId == item.userId) {
          flag = false;
          return true;
        }
      });
      //添加查重
      if (flag) {
        this.$message.success(this.$t("msg.successMsg"));
        this.tableList = this.tableList.concat(item);
      } else {
        this.$message.error(this.$t("common.addRepeatly"));
      }
    },
    //拖拽
    getdata(evt) {
      console.log(evt.draggedContext.element.id);
    },
    datadragEnd(evt) {
      console.log("拖动前的索引 :" + evt.oldIndex);
      console.log("拖动后的索引 :" + evt.newIndex);
      console.log(this.tablelist);
    },

    //列表删除
    handleDelete(index, row) {
      this.currentId = index;
      this.$refs["delete"].openDialog();
    },
    confirmDelete() {
      this.tableList.splice(this.currentId, 1);
      this.$refs["delete"].closeDialog();
      this.$message.success(this.$t("msg.successMsg"));
    },
    handleClose(done) {
      done();
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => {});
    },
    //点击按钮 搜索用户
    handleSearchUserOpen() {
      this.paramSingleDocCode;
      this.$refs["search-add-user"].handleOpen(this.paramSingleDocCode);
    },
    handleCreateUserOpen() {
      this.$refs["search-create-user"].handleOpen(this.paramSingleDocCode);
    },
  },
};
</script>

<style scoped lang="scss">
.dataTabble {
  width: 100%;
  thead {
    width: 100%;
    tr {
      height: 60px;
      font-size: 14px;
      border-bottom: 1px solid #e4e9ef;
      color: #979797;
    }
    th {
      padding: 0 10px;
    }
  }
  tbody {
    tr {
      height: 60px;
      font-size: 16px;
      border-bottom: 1px solid #e4e9ef;
      transition: background-color 0.2s;
    }
    tr:hover {
      background: #f5f7fa;
    }
    td {
      padding: 0 10px;
      font-size: 14px;
    }
  }
}
</style>
